import { Component, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Tooltip } from '../../model/content/contentTooltip.model';
import { HelpModalDirective } from '../help-modal.directive';

declare let delta: any;

@Component({
  selector: 'ngc-checkin-ticket-no',
  templateUrl: 'checkin-ticket-no.component.html'
})
export class CheckinTicketNoComponent {
  @ViewChild('helpDialog') helpDialog: any;
  isModalShown = false;
  helpModalDir: HelpModalDirective;
  tooltipContent: Tooltip;

  modalConfig = {
    animated: false,
    show: true
  };

  constructor(public bsModalRef: BsModalRef) {}

  close() {
    this.bsModalRef.hide();
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
  }
}
